var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill"},[_c('v-btn',{staticClass:"btn mt-4",attrs:{"color":"primary"},on:{"click":_vm.stripeCheckout}},[_vm._v(_vm._s(_vm.buttonText ? _vm.buttonText : 'Stripe Checkout Test')+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }